'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of unpacked
 */ const Unpacked = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 105",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M104 52.6738C104 81.3926 80.7188 104.674 52 104.674C23.2812 104.674 0 81.3926 0 52.6738C0 23.955 23.2812 0.673828 52 0.673828C80.7188 0.673828 104 23.955 104 52.6738Z",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M40.2293 34.053L24.0596 33.7117L25.1443 34.854L34.9231 45.0097L50.8563 45.0097L40.2293 34.053Z",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M67.5195 45.0098H83.4527V79.0488H67.5195V45.0098Z",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M78.1418 34.0452L94.3115 33.7039L93.2268 34.8462L83.4479 45.0019L67.5148 45.0019L78.1418 34.0452Z",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M34.9297 45.0098H67.5202V79.0488H34.9297V45.0098Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("g", {
                clipPath: "url(#clip0_3427_21994)",
                children: /*#__PURE__*/ jsxRuntime.jsx("path", {
                    d: "M56 61.0226C56 61.0226 56 61.0447 56 61.0668C56 61.2433 55.7299 64.9505 51.0709 66.6275V64.3105L53.8843 61.3095C54.1319 61.0447 54.1319 60.6255 53.8393 60.3607C53.5692 60.1179 53.1416 60.1179 52.8715 60.4048L51.0709 62.3466V60.3607C51.0709 60.3607 51.0709 60.3607 51.0709 60.3386C51.2959 59.8311 52.3763 57.8451 55.0322 57.8451C55.0547 57.8451 55.0772 57.8451 55.0997 57.8451C56.1576 59.0808 56 61.0006 56 61.0226ZM49.7204 62.3466L47.8973 60.4048C47.6497 60.14 47.222 60.1179 46.952 60.3607C46.6819 60.6034 46.6594 61.0447 46.9069 61.3095L49.7204 64.3105V66.6054C45.0613 64.9284 44.8137 61.1992 44.7912 61.0447C44.7912 61.0226 44.7912 61.0226 44.7912 61.0006C44.7912 60.9785 44.6112 59.0587 45.669 57.823C45.6915 57.823 45.714 57.823 45.759 57.823C48.4375 57.823 49.4953 59.8311 49.7204 60.3165C49.7204 60.3165 49.7204 60.3165 49.7204 60.3386V62.3466ZM55.91 56.6976C55.7975 56.5873 55.6399 56.5211 55.4824 56.4991C52.939 56.3446 51.2734 57.6244 50.3956 58.816C49.5178 57.6244 47.8748 56.3446 45.3089 56.4991C45.1513 56.4991 44.9938 56.5873 44.8812 56.6976C43.2382 58.3085 43.4183 60.8682 43.4408 61.1109C43.4408 61.2874 43.5533 62.5452 44.3861 64.0016C45.1738 65.3918 46.8394 67.2233 50.148 68.1501C50.1705 68.1501 50.1931 68.1501 50.1931 68.1721C50.2156 68.1721 50.2156 68.1721 50.2381 68.1721C50.2606 68.1721 50.2606 68.1721 50.2831 68.1721C50.3056 68.1721 50.3506 68.1721 50.3731 68.1721C50.3956 68.1721 50.4406 68.1721 50.4631 68.1721C50.4857 68.1721 50.4857 68.1721 50.5082 68.1721C50.5307 68.1721 50.5307 68.1721 50.5532 68.1721C50.5757 68.1721 50.5982 68.1721 50.6207 68.1501C56.7653 66.451 57.3055 61.5964 57.328 61.133C57.3505 61.0006 57.5756 58.3526 55.91 56.6976Z",
                    fill: theme.ds5.asset.grey["700"]
                })
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M28.7399 59.1522V56.9683H28.7927C29.632 56.9683 30.3123 56.2879 30.3123 55.4487V54.3536C30.3123 53.5143 29.632 52.834 28.7927 52.834H17.422C16.5828 52.834 15.9024 53.5143 15.9024 54.3536V55.4487C15.9024 56.2879 16.5828 56.9683 17.422 56.9683H17.4748V59.1845C16.612 59.4996 15.868 60.0664 15.3425 60.8089C14.8171 61.5514 14.5353 62.434 14.5352 63.3382V77.572C14.5352 78.4112 15.2155 79.0916 16.0547 79.0916H30.255C31.0943 79.0916 31.7746 78.4112 31.7746 77.572V63.3402C31.7746 62.4189 31.4823 61.5205 30.9384 60.7699C30.3945 60.0193 29.6261 59.4539 28.7399 59.1522Z",
                fill: theme.ds5.asset[assetColor].backItem
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M39.7394 63.025V61.1402C40.4888 61.1402 41.0964 60.5327 41.0964 59.7832V59.0918C41.0964 58.2526 40.416 57.5723 39.5768 57.5723H30.18C29.3408 57.5723 28.6605 58.2526 28.6605 59.0918V59.7832C28.6605 60.5327 29.268 61.1402 30.0174 61.1402V63.0528C29.2728 63.3248 28.6307 63.814 28.1772 64.4547C27.7237 65.0955 27.4806 65.8572 27.4805 66.6376V78.7134C27.4805 79.5526 28.1608 80.2329 29 80.2329H40.8388C41.678 80.2329 42.3584 79.5526 42.3584 78.7134V66.6393C42.3583 65.8442 42.1061 65.0689 41.6367 64.4211C41.1673 63.7733 40.5041 63.2854 39.7394 63.025Z",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "15.7617",
                y: "52.8242",
                width: "14.6449",
                height: "4.0612",
                rx: "0.555027",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "28.4336",
                y: "57.5938",
                width: "12.7989",
                height: "3.44587",
                rx: "0.555027",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("defs", {
                children: /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                    id: "clip0_3427_21994",
                    children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                        width: "14.1798",
                        height: "11.9158",
                        fill: "white",
                        transform: "translate(43.3057 56.3887)"
                    })
                })
            })
        ]
    });
};

exports.Unpacked = Unpacked;
//# sourceMappingURL=Unpacked.cjs.map
